/* eslint-disable import/no-unresolved */
import { roleIDs } from "src/config/constant";

export const documentsTypes: Record<string, TDocumentType> = {
  mef_pdf: "MEF",
  bi_pdf: "BI",
  loan_sanction_letter: "Loan Sanction Letter",
  id_proof: "ID Proof",
  others: "Other"
};

type TDocumentType = "MEF" | "BI" | "Loan Sanction Letter" | "ID Proof" | "Other" | "";
export interface IUploadFiles {
  documentType?: TDocumentType;
  file?: Record<string, any>;
}
export interface CreateLeadsDetails {
  [key: string]: any;
  productId: number | null;
  applicationNumber: string;
  bankBranchName: string;
  loanType: string;
  loanAccountNo: string;
  channel: string;
  partnerId: string;
  bankVertical: string;
  solId: string;
  lgCode: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  customerDOB: string;
  customerMobileNumber: string;
  customerPAN: string;
  customerEmail: string;
  customerGender: string;
  applicationSignedDate: string;
  loanAmount: number | null;
  loanTerm: string;
  policyTerm: string;
  premiumPaymentTerm: number | null;
  premiumPaymentTermCode?: string;
  loanInterestRate: string;
  sumAssured: number | null;
  files?: IUploadFiles[];
}

export const uploadFilesMandatoryFor = (role: string) => [roleIDs.irm]?.includes(role);

export const hideToEditMEFButton = (role: string) => ![roleIDs.irm]?.includes(role);
